"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
/* We will return an instance of this class of User insted of Sequelize objects */
/* If we need to get another attribute from de DB, we only just add to this class attributes */
/* The parse function of BaseModel will take care of the rest. */
/* Internal use interfaces */
var Address = (function (_super) {
    __extends(Address, _super);
    function Address() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.address = undefined;
        _this.number = undefined; // Street number should be a string eg: '1273 BIS'
        _this.apt = undefined;
        _this.city = undefined;
        _this.departament = undefined;
        _this.zip = undefined;
        return _this;
    }
    return Address;
}(BaseModel_1["default"]));
exports.Address = Address;
var UserRequest;
(function (UserRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.phone = undefined;
            _this.address = undefined;
            _this.userRoleId = undefined;
            _this.active = undefined;
            _this.deletedAt = undefined;
            _this.socialId = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    UserRequest.Create = Create;
    var Login = (function (_super) {
        __extends(Login, _super);
        function Login() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.email = undefined;
            _this.password = undefined;
            return _this;
        }
        return Login;
    }(BaseModel_1["default"]));
    UserRequest.Login = Login;
    var SocialLogin = (function (_super) {
        __extends(SocialLogin, _super);
        function SocialLogin() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.accessToken = undefined;
            _this.email = undefined;
            return _this;
        }
        return SocialLogin;
    }(BaseModel_1["default"]));
    UserRequest.SocialLogin = SocialLogin;
    var Subscribe = (function (_super) {
        __extends(Subscribe, _super);
        function Subscribe() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.email = undefined;
            _this.firstName = undefined;
            _this.lastName = undefined;
            return _this;
        }
        return Subscribe;
    }(BaseModel_1["default"]));
    UserRequest.Subscribe = Subscribe;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.phone = undefined;
            _this.address = undefined;
            _this.active = undefined;
            _this.deletedAt = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    UserRequest.Update = Update;
    var SendResetPasswordToken = (function (_super) {
        __extends(SendResetPasswordToken, _super);
        function SendResetPasswordToken() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.email = undefined;
            return _this;
        }
        return SendResetPasswordToken;
    }(BaseModel_1["default"]));
    UserRequest.SendResetPasswordToken = SendResetPasswordToken;
    var ResetPassword = (function (_super) {
        __extends(ResetPassword, _super);
        function ResetPassword() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.newPassword = undefined;
            return _this;
        }
        return ResetPassword;
    }(BaseModel_1["default"]));
    UserRequest.ResetPassword = ResetPassword;
    var ChangePassword = (function (_super) {
        __extends(ChangePassword, _super);
        function ChangePassword() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.oldPassword = undefined;
            _this.newPassword = undefined;
            _this.confirmPassword = undefined;
            return _this;
        }
        return ChangePassword;
    }(BaseModel_1["default"]));
    UserRequest.ChangePassword = ChangePassword;
})(UserRequest = exports.UserRequest || (exports.UserRequest = {}));
var UserResponse;
(function (UserResponse) {
    var User = (function (_super) {
        __extends(User, _super);
        function User() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.phone = undefined;
            _this.address = undefined;
            _this.number = undefined;
            _this.apt = undefined;
            _this.city = undefined;
            _this.departament = undefined;
            _this.zip = undefined;
            _this.userRoleId = undefined;
            _this.active = undefined;
            _this.socialId = undefined;
            _this.deletedAt = undefined;
            return _this;
        }
        return User;
    }(BaseModel_1["default"]));
    UserResponse.User = User;
    var RefreshToken = (function () {
        function RefreshToken() {
            this.token = undefined;
            this.expiresIn = undefined;
        }
        return RefreshToken;
    }());
    UserResponse.RefreshToken = RefreshToken;
    var Auth = (function () {
        function Auth() {
            this.token = undefined;
            this.expiresIn = undefined;
            this.refreshToken = undefined;
        }
        return Auth;
    }());
    UserResponse.Auth = Auth;
    var UserDecoded = (function () {
        function UserDecoded() {
            this.id = undefined;
            this.name = undefined;
            this.role = undefined;
            this.active = undefined;
            this.email = undefined;
            this.exp = undefined;
            this.iat = undefined;
        }
        return UserDecoded;
    }());
    UserResponse.UserDecoded = UserDecoded;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length;
            _this.offset = offset;
            _this.pagination = pagination;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    UserResponse.All = All;
})(UserResponse = exports.UserResponse || (exports.UserResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/user.js
// module id = ../model/dist/models/user.js
// module chunks = main